import { useParams } from "react-router-dom"
import { CloudUpload } from "@mui/icons-material"
import { useAppSelector } from "hooks/redux"
import useCancelUploadPrompt from "hooks/upload-cancel-prompt"
import HomeHeader from "modules/home-header"
import { getCurrentPortfolio } from "modules/portfolio-root/selectors/portfolios"
import { Creators } from "./model"
import { getPortfolioUrlSegment } from "./selectors"

interface Props {
  account: string
}

export default function PortfolioPositionsHeader({ account }: Props) {
  const params = useParams()
  // Keyed on `global.selected.portfolio`, the same decider the fetch uses — `useParams` is decoded
  // and the selected id is not, so an id needing encoding would never match.
  const portfolio = useAppSelector(getCurrentPortfolio)
  const portfolioSegment = useAppSelector(getPortfolioUrlSegment)
  // Only the experiment route carries :experimentId, so the bar knows which upload this is with
  // nothing loaded.
  const isExperiment = !!params.experimentId
  const returnTo = isExperiment
    ? `/${account}/p/${portfolioSegment}/rebalance/experiments/`
    : `/${account}/home/resources`
  const promptCancel = useCancelUploadPrompt(returnTo, Creators.resetUpload)

  let title = "Upload"
  if (isExperiment) {
    title = "Upload Alternative Experiment"
  } else if (portfolio) {
    title = `Upload positions for ${portfolio.name}`
  }

  return <HomeHeader account={account} Icon={CloudUpload} title={title} onLogoClick={promptCancel} />
}
